import React, { Component } from "react";
import PropTypes from "prop-types";
import City from "@views/product-list/components/search-box/city";
import DateRange from "@views/product-list/components/search-box/date-range";
import { moduleEdit } from "@shared/lingxi/core";
import { selectCheckDate } from "./search-box-register";

export default class SearchBox extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      conditions: props.defaultConditions,
    };
    this._cityPinyin = props.defaultCityPinyin;
    this._cityName = props.defaultCityName;
  }

  handleChange(appendValue) {
    const newConditions = {
      ...this.state.conditions,
      ...appendValue,
    };
    this.setState({ conditions: newConditions });
  }
  renderFormContent() {
    const { conditions } = this.state;
    const { cityId, dateBegin, dateEnd } = conditions;
    const cityPinyin = this._cityPinyin;
    const cityName = this._cityName;
    const useCityId = !cityPinyin;
    return (
      <div className="home-search-bar" data-city={cityName}>
        {!(useCityId && cityId) || <input type="hidden" name="cityId" value={cityId} />}
        {!dateBegin || <input type="hidden" name="dateBegin" value={dateBegin} />}
        {!dateEnd || <input type="hidden" name="dateEnd" value={dateEnd} />}
        <ul className="search-bar list-inline">
          {!this.props.noCity && (
            <li className="search-bar__menu search-bar__menu--city">
              <City
                cities={this.props.cities}
                value={conditions.cityId}
                dontRenderDropdown={this.props.dontRenderCityDropdown}
                onChange={({ cityId, pynm, cityName }) => {
                  this.handleChange({ cityId });
                  this._cityPinyin = pynm;
                  this._cityName = cityName;
                }}
              />
            </li>
          )}
          <li className="search-bar__menu search-bar__menu--date">
            <DateRange
              value={{ dateBegin: conditions.dateBegin, dateEnd: conditions.dateEnd }}
              onChange={value => {
                this.handleChange(value);
                moduleEdit("选择入离日期", selectCheckDate(cityName, value));
              }}
              format={["YYYY-MM-DD入住", "YYYY-MM-DD离开"]}
              hyphen="&nbsp;&nbsp;"
            />
          </li>
          <li className="search-bar__menu search-bar__menu__btn">
            <button className="btn btn-primary btn-lg btn--search" type="submit">
              搜索
            </button>
          </li>
        </ul>
      </div>
    );
  }
  render() {
    const cityPinyin = this._cityPinyin;
    const cityName = this._cityName;
    const useCityId = !cityPinyin;

    const listUrl = `/${useCityId ? "housing" : cityPinyin}/`;

    if (this.props.unmanagedForm) {
      return this.renderFormContent();
    }
    return (
      <form method="GET" action={listUrl} data-city={cityName}>
        {this.renderFormContent()}
      </form>
    );
  }
}

SearchBox.propTypes = {
  cities: PropTypes.array,
  defaultConditions: PropTypes.object,
  defaultCityName: PropTypes.string,
  defaultCityPinyin: PropTypes.string,
  dontRenderCityDropdown: PropTypes.bool,
  noCity: PropTypes.bool,
  unmanagedForm: PropTypes.bool,
};

SearchBox.defaultProps = {
  cities: [],
  defaultConditions: {},
  defaultCityName: "",
  defaultCityPinyin: "",
  dontRenderCityDropdown: false,
  noCity: false,
  unmanagedForm: false,
};

require("./search-box.less");